import { Component, computed, inject, Signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DialogComponent } from '../../../../components/dialogs/dialog/dialog.component';
import { Dialog } from '../../../../components/dialogs/dialog';
import { ICmsTicketOverviewItem, ILayout, ILayoutAssignment } from '@web/dtos';
import { DropDownComponent } from '../../../../components/data-input/form-inputs/drop-down/drop-down.component';
import { ButtonComponent } from '../../../../components/feedback/button/button.component';
import { LayoutsStore } from '../../../../services/api/layouts/layouts-store.service';
import { CmsTextProviderService } from '../../../../services/cms-text-provider.service';
import { SimpleTableComponent } from '../../../../components/data-display/simple-table/simple-table.component';

export interface ISortimentLayoutAssignmentDialogData {
  selectedTicket: ICmsTicketOverviewItem;
  layoutAssignments: ILayoutAssignment[];
}

interface ILayoutAssignmentRow {
  sortId: string;
  layoutIdControl: FormControl<string>;
}

interface ILayoutOption {
  id: string;
  layoutName: string;
}

@Component({
  selector: 'aw-sortiment-layout-assignment',
  imports: [
    DialogComponent,
    DropDownComponent,
    ButtonComponent,
    ReactiveFormsModule,
    SimpleTableComponent,
  ],
  templateUrl: './sortiment-layout-assignment.component.html',
})
export class SortimentLayoutAssignmentComponent extends Dialog<ISortimentLayoutAssignmentDialogData> {
  protected readonly layoutsStore: LayoutsStore = inject(LayoutsStore);
  protected readonly cmsTextProvider: CmsTextProviderService = inject(
    CmsTextProviderService
  );
  protected readonly form: FormGroup = new FormGroup({});

  protected readonly layoutOptions: Signal<ILayoutOption[]> = computed(
    (): ILayoutOption[] => [
      { id: '', layoutName: '-' },
      ...this.layoutsStore
        .layouts()
        .flatMap((layout: ILayout): ILayoutOption[] =>
          layout.id ? [{ id: layout.id, layoutName: layout.layoutName }] : []
        ),
    ]
  );

  protected readonly rows: ILayoutAssignmentRow[] =
    this.data.selectedTicket.sortenExterneReferenzen.map(
      (sortId: string): ILayoutAssignmentRow => ({
        sortId,
        layoutIdControl: new FormControl<string>(
          this.data.layoutAssignments.find(
            (assignment: ILayoutAssignment): boolean =>
              assignment.sortId === sortId
          )?.layoutId ?? '',
          { nonNullable: true }
        ),
      })
    );

  protected confirm(): void {
    const layoutAssignments: ILayoutAssignment[] = this.rows
      .filter(
        (row: ILayoutAssignmentRow): boolean => !!row.layoutIdControl.value
      )
      .map(
        (row: ILayoutAssignmentRow): ILayoutAssignment => ({
          layoutId: row.layoutIdControl.value,
          sortId: row.sortId,
          lastEditedAt: new Date(),
        })
      );

    this.dialogRef.close({
      submit: true,
      acceptChanges: false,
      data: {
        ...this.data,
        layoutAssignments,
      },
    });
  }
}
